import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import httpClient from '../../http/client';
import { Disclaimers, disclaimersURL } from './disclaimersAPI';

export interface DisclaimersState {
  plans: string;
  checkout: string;
  status: 'idle' | 'loading' | 'failed';
}

const initialState: DisclaimersState = {
  plans: '',
  checkout: '',
  status: 'idle',
};

// The http client resolves an error response too, so a body is not always
// the disclaimers.
const textOf = (value: unknown): string => (
  typeof value === 'string' ? value : ''
);

export const fetchDisclaimersAsync = createAsyncThunk(
  'disclaimers/fetchDisclaimers',
  async () => {
    const response = await httpClient.get<Disclaimers>(disclaimersURL());
    return response.data;
  },
);

export const disclaimersSlice = createSlice({
  name: 'disclaimers',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDisclaimersAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchDisclaimersAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.plans = textOf(action.payload?.plans);
        state.checkout = textOf(action.payload?.checkout);
      })
      .addCase(fetchDisclaimersAsync.rejected, (state) => {
        state.status = 'failed';
        state.plans = '';
        state.checkout = '';
      });
  },
});

export const selectPlansDisclaimer = (state: RootState) => (
  state.disclaimers.plans
);
export const selectCheckoutDisclaimer = (state: RootState) => (
  state.disclaimers.checkout
);
export default disclaimersSlice.reducer;
